<template>
  <div
    class="main-menu menu-fixed menu-accordion menu-shadow"
    :class="[
      {
        expanded:
          !isVerticalMenuCollapsed ||
          (isVerticalMenuCollapsed && isMouseHovered),
      },
      skin === 'semi-dark' ? 'menu-dark' : 'menu-light',
    ]"
    @mouseenter="updateMouseHovered(true)"
    @mouseleave="updateMouseHovered(false)"
  >
    <!-- main menu header-->
    <div class="navbar-header expanded">
      <slot
        name="header"
        :toggleVerticalMenuActive="toggleVerticalMenuActive"
        :toggleCollapsed="toggleCollapsed"
        :collapseTogglerIcon="collapseTogglerIcon"
      >
        <div class="logo-brand" @click="pushLanding">
          <div class="brand-img"></div>
        </div>
      </slot>
    </div>
    <!-- / main menu header-->
    <div class="brand-name">
      <div>
        {{ $store.getters["brand/brandName"] }}
      </div>
    </div>
    <!-- Shadow -->
    <div :class="{ 'd-block': shallShadowBottom }" class="shadow-bottom" />

    <!-- main menu content-->
    <vue-perfect-scrollbar
      :settings="perfectScrollbarSettings"
      class="main-menu-content scroll-area"
      tagname="ul"
      @ps-scroll-y="
        (evt) => {
          shallShadowBottom = evt.srcElement.scrollTop > 200;
        }
      "
    >
      <vertical-nav-menu-items
        :items="renderNavMenu"
        class="navigation navigation-main"
      />
    </vue-perfect-scrollbar>
    <!-- /main menu content-->
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { BLink, BImg } from "bootstrap-vue";
import { provide, computed, ref } from "@vue/composition-api";
import useAppConfig from "@core/app-config/useAppConfig";
import { $themeConfig } from "@themeConfig";
import VerticalNavMenuItems from "./components/vertical-nav-menu-items/VerticalNavMenuItems.vue";
import useVerticalNavMenu from "./useVerticalNavMenu";
import router from "@/router";
import store from "@/store";
import { namespaceCode } from "@/configs/namespace-code/namespace-code";

export default {
  components: {
    VuePerfectScrollbar,
    VerticalNavMenuItems,
    BLink,
    BImg,
  },
  props: {
    isVerticalMenuActive: {
      type: Boolean,
      required: true,
    },
    toggleVerticalMenuActive: {
      type: Function,
      required: true,
    },
  },
  setup(props) {
    const {
      isMouseHovered,
      isVerticalMenuCollapsed,
      collapseTogglerIcon,
      toggleCollapsed,
      updateMouseHovered,
    } = useVerticalNavMenu(props);

    const namespace = namespaceCode;

    const { skin } = useAppConfig();

    // Shadow bottom is UI specific and can be removed by user => It's not in `useVerticalNavMenu`
    const shallShadowBottom = ref(false);

    provide("isMouseHovered", isMouseHovered);

    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: false,
    };

    const collapseTogglerIconFeather = computed(() =>
      collapseTogglerIcon.value === "unpinned" ? "CircleIcon" : "DiscIcon"
    );

    // App Name
    const { appName, appLogoImage } = $themeConfig.app;

    const pushLanding = () => {
      router.push("/landing").catch(() => {});
    };

    const renderNavMenu = computed(() => {
      // hard code nav bar for ntl only
      let searchParams = new URLSearchParams(window.location.search);
      let brandRef = searchParams.get("brandRef");
      let brand_ref = searchParams.get("brand_ref");
      let session = sessionStorage.getItem(window.brandSessionStorage);

      if ([brandRef, brand_ref, session].indexOf("B6H5XQ21PPCM") >= 0) {
        let link = store.getters["verticalMenu/menuList"].find((o) => {
          return o.ns_code == 99;
        }).custom_description;
        // set custom link
        if (link) {
          store.commit("brand/SET_CUSTOM_MODULE_LINK", link);
        }
        return require(`@/constants/navigation/${brandRef ||
          brand_ref ||
          session}/navigation-custom`)?.default;
      } // end hard code ntl
      else if ([brandRef, brand_ref, session].indexOf("BHMVVDXV3W7E") >= 0) {
        let link = store.getters["verticalMenu/menuList"].find((o) => {
          return o.ns_code == 99;
        }).custom_description;
        // set custom link
        if (link) {
          store.commit("brand/SET_CUSTOM_MODULE_LINK", link);
        }
        return require(`@/constants/navigation/${brandRef ||
          brand_ref ||
          session}/navigation-custom`)?.default;
      } // end hard code yuzu group
      else if ([brandRef, brand_ref, session].indexOf("BKIMIKYVPFZC") >= 0) {
        let link = store.getters["verticalMenu/menuList"].find((o) => {
          return o.ns_code == 99;
        }).custom_description;
        // set custom link
        if (link) {
          store.commit("brand/SET_CUSTOM_MODULE_LINK", link);
        }
        return require(`@/constants/navigation/${brandRef ||
          brand_ref ||
          session}/navigation-custom`)?.default;
      } // end hard code mqdc
      else if ([brandRef, brand_ref, session].indexOf("BCIHGEEJZQZ0") >= 0) {
        let link = store.getters["verticalMenu/menuList"].find((o) => {
          return o.ns_code == 99;
        })?.custom_description;
        // set custom link
        if (link) {
          store.commit("brand/SET_CUSTOM_MODULE_LINK", link);
        }
        return require(`@/constants/navigation/${brandRef ||
          brand_ref ||
          session}/navigation-custom`)?.default;
      } // end hard code dna
      else if ([brandRef, brand_ref, session].indexOf("B2TJ9OYIZBO1") >= 0) {
        let link = store.getters["verticalMenu/menuList"].find((o) => {
          return o.ns_code == 99;
        })?.custom_description;
        // set custom link
        if (link) {
          store.commit("brand/SET_CUSTOM_MODULE_LINK", link);
        }
        return require(`@/constants/navigation/${brandRef ||
          brand_ref ||
          session}/navigation-custom`)?.default;
      } // end hard code Ovaltine Club
      else if ([brandRef, brand_ref, session].indexOf("B2F5567SU77V") >= 0) {
        let link = store.getters["verticalMenu/menuList"].find((o) => {
          return o.ns_code == 99;
        })?.custom_description;
        // set custom link
        if (link) {
          store.commit("brand/SET_CUSTOM_MODULE_LINK", link);
        }
        return require(`@/constants/navigation/${brandRef ||
          brand_ref ||
          session}/navigation-custom`)?.default;
      } // end hard code Lubricants
      else if ([brandRef, brand_ref, session].indexOf("BPQBG6AEJOOE") >= 0) {
        let link = store.getters["verticalMenu/menuList"].find((o) => {
          return o.ns_code == 99;
        })?.custom_description;
        // set custom link
        if (link) {
          store.commit("brand/SET_CUSTOM_MODULE_LINK", link);
        }
        return require(`@/constants/navigation/${brandRef ||
          brand_ref ||
          session}/navigation-custom`)?.default;
      } // end hard code baac
      else if ([brandRef, brand_ref, session].indexOf("BUSDOAIGQZSP") >= 0) {
        let link = store.getters["verticalMenu/menuList"].find((o) => {
          return o.ns_code == 99;
        })?.custom_description;
        // set custom link
        if (link) {
          store.commit("brand/SET_CUSTOM_MODULE_LINK", link);
        }
        return require(`@/constants/navigation/${brandRef ||
          brand_ref ||
          session}/navigation-custom`)?.default;
      } // end hard code Bay-mini
      else if ([brandRef, brand_ref, session].indexOf("B1NJUHN5VWTO") >= 0) {
        let link = store.getters["verticalMenu/menuList"].find((o) => {
          return o.ns_code == 99;
        })?.custom_description;
        // set custom link
        if (link) {
          store.commit("brand/SET_CUSTOM_MODULE_LINK", link);
        }
        return require(`@/constants/navigation/${brandRef ||
          brand_ref ||
          session}/navigation-custom`)?.default;
      } // end hard code BAY Mini on UAT
      else if ([brandRef, brand_ref, session].indexOf("BOYNYKJMS2EH") >= 0) {
        let link = store.getters["verticalMenu/menuList"].find((o) => {
          return o.ns_code == 99;
        })?.custom_description;
        // set custom link
        if (link) {
          store.commit("brand/SET_CUSTOM_MODULE_LINK", link);
        }
        return require(`@/constants/navigation/${brandRef ||
          brand_ref ||
          session}/navigation-custom`)?.default;
      } // end hard code MBK

      // default logic nav bar for any brands
      let navigation = [];
      store.getters["verticalMenu/menuList"].map((o) => {
        // check default module
        if (o.ns_code != 99) {
          try {
            navigation.push(
              ...[
                {
                  title: o.module_name,
                  customIcon: o.module_icon,
                  children: o.custom_config
                    ? JSON.parse(o.custom_config)
                    : require(`@/navigation/${namespace["" + o.ns_code]}`)
                        ?.default[0].children,
                },
              ]
            );
          } catch {
            navigation.push(
              ...[
                {
                  title: o.module_name,
                  customIcon: o.module_icon,
                },
              ]
            );
          }
        } else {
          // else custom module to this
          try {
            // set custom link
            if (o.custom_description) {
              store.commit(
                "brand/SET_CUSTOM_MODULE_LINK",
                o.custom_description
              );
            }
            navigation.push(
              ...[
                {
                  title: o.module_name,
                  customIcon: o.module_icon,
                  children: JSON.parse(o.custom_config),
                },
              ]
            );
          } catch {}
        }
      });
      return navigation;
    });

    return {
      renderNavMenu,
      perfectScrollbarSettings,
      isVerticalMenuCollapsed,
      collapseTogglerIcon,
      toggleCollapsed,
      isMouseHovered,
      updateMouseHovered,
      collapseTogglerIconFeather,
      pushLanding,

      // Shadow Bottom
      shallShadowBottom,

      // Skin
      skin,

      // App Name
      appName,
      appLogoImage,
    };
  },
};
</script>

<style scoped>
@import "~@/assets/css/override-styles/vertical-navbar.css";
</style>

<style lang="scss">
@import "~@core/scss/base/core/menu/menu-types/vertical-menu.scss";
</style>
